export default "__VITE_ASSET__I3aNZLLL__"